import { H3Wrap } from './styles';

import type { H3Interface } from './interface';

const H3 = ({ children }: H3Interface) => (
    <H3Wrap className="h3-atom">{children}</H3Wrap>
);

export default H3;
